/* NIVIÈREE · página de coleção: cor, visualização da grade, ordenação e filtros · 22-10-2026
 *
 * Cor: os quadradinhos ficam dentro da gaveta de Filtros (facets-vertical.liquid).
 *   Sem o filtro Cor do Search & Discovery (modo "view"), eles trocam a foto e a ordem
 *   das bolinhas de cada card para a cor escolhida, sem esconder produtos. Com o filtro
 *   Cor ativado, o próprio filtro do tema aparece na gaveta no lugar deles.
 *   A gaveta é levada para o fim da página ao abrir, então a busca é no documento todo.
 * Barra: não fica mais presa no topo ao rolar (22-10-2026).
 * Visualização: celular 2/1/4 (só foto), desktop 4/6/10 (só foto). A escolha fica
 *   salva no navegador de quem visita (localStorage).
 * Ordenar no celular: abaixo de 1000px o tema leva o menu Ordenar para o fim da página
 *   ao abrir, e a escolha deixava de chegar à barra (a ordenação não acontecia). Aqui a
 *   escolha é repassada para a barra e a cópia que sobra no fim da página é removida.
 * Filtros: o botão Limpar da gaveta é tratado aqui (a gaveta também vai para o fim da
 *   página ao abrir) e o número do Aplicar conta só filtros, não a ordenação.
 *
 * Carrega depois de nivieree-product-grid.js (ambos com defer), então os cards já
 * estão preparados quando este script começa.
 */
(() => {
  const ORDER = {
    'preto': ['preto', 'branco', 'off-white', 'azul-marinho'],
    'branco': ['branco', 'off-white', 'preto', 'azul-marinho'],
    'off-white': ['off-white', 'branco', 'preto', 'azul-marinho'],
    'azul-marinho': ['azul-marinho', 'preto', 'branco', 'off-white'],
  };

  const KEY = 'nvr-collection-color';
  const VIEW_KEY = 'nvr-grid-view';
  const VIEWS = { m: ['2', '1', '4'], d: ['4', '6', '10'] };
  const SECTION = '.shopify-section--main-collection';
  const GRID_CARDS = SECTION + ' [data-nivieree-card]';

  const norm = (value) => String(value || '').toLowerCase().trim().replace(/\s+/g, '-');

  const store = {
    get() {
      try { return sessionStorage.getItem(KEY) || ''; } catch (_e) { return ''; }
    },
    set(value) {
      try {
        if (value) sessionStorage.setItem(KEY, value);
        else sessionStorage.removeItem(KEY);
      } catch (_e) { /* sem armazenamento: só vale para esta página */ }
    },
  };

  const getBars = () => Array.from(document.querySelectorAll('[data-nvr-color-bar]'));
  const isViewMode = () => getBars().some((bar) => bar.dataset.mode === 'view');

  const labelOf = (input) => {
    const label = input.nextElementSibling;
    if (!label) return '';
    const sr = label.querySelector('.sr-only');
    return (sr ? sr.textContent : label.textContent).trim();
  };

  /* ---------- Cor ---------- */

  const reorder = (fieldset, lead) => {
    const order = ORDER[lead];
    if (!order) return;

    const rank = (name) => {
      const index = order.indexOf(norm(name));
      return index < 0 ? 99 : index;
    };

    const pairs = Array.from(fieldset.querySelectorAll('input[type="radio"]'))
      .map((input) => [input, input.nextElementSibling])
      .sort((a, b) => rank(labelOf(a[0])) - rank(labelOf(b[0])));

    const anchor = fieldset.querySelector('.color-swatch__view-more');
    pairs.forEach(([input, label]) => {
      fieldset.insertBefore(input, anchor);
      if (label) fieldset.insertBefore(label, anchor);
    });
  };

  const applyToCard = (card, color) => {
    const fieldset = card.querySelector('.nivieree-card__swatches');
    if (!fieldset) return;

    const inputs = Array.from(fieldset.querySelectorAll('input[type="radio"]'));

    if (card.dataset.nvrDefaultColor === undefined) {
      const initial = inputs.find((input) => input.checked);
      card.dataset.nvrDefaultColor = initial ? norm(labelOf(initial)) : '';
    }

    const wanted = color || card.dataset.nvrDefaultColor;
    const input = inputs.find((item) => norm(labelOf(item)) === wanted);

    if (input) {
      // Dispara mesmo se a cor já estiver marcada, para a foto acompanhar a cor.
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    reorder(fieldset, input ? wanted : card.dataset.nvrDefaultColor);
  };

  const syncBar = (color) => {
    getBars().forEach((bar) => bar.querySelectorAll('[data-nvr-color]').forEach((dot) => {
      const active = dot.dataset.nvrColor === color;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-pressed', active ? 'true' : 'false');
    }));
  };

  const cardsIn = (root) => {
    if (root.matches?.(GRID_CARDS)) return [root];
    return Array.from(root.querySelectorAll?.(GRID_CARDS) || []);
  };

  const applyColor = (root = document) => {
    if (!isViewMode()) return;
    const color = store.get();
    syncBar(color);
    if (!color) return;
    cardsIn(root).forEach((card) => applyToCard(card, color));
  };

  /* ---------- Visualização da grade ---------- */

  const readViews = () => {
    try {
      const value = JSON.parse(localStorage.getItem(VIEW_KEY) || '{}');
      return value && typeof value === 'object' ? value : {};
    } catch (_e) {
      return {};
    }
  };

  const writeViews = (value) => {
    try { localStorage.setItem(VIEW_KEY, JSON.stringify(value)); } catch (_e) { /* só vale para esta página */ }
  };

  let sessionViews = null; // usado quando o navegador não deixa salvar

  const currentViews = () => {
    const saved = sessionViews || readViews();
    return {
      m: VIEWS.m.includes(saved.m) ? saved.m : VIEWS.m[0],
      d: VIEWS.d.includes(saved.d) ? saved.d : VIEWS.d[0],
    };
  };

  const applyViews = () => {
    const section = document.querySelector(SECTION);
    if (!section) return;

    const views = currentViews();
    section.setAttribute('data-nvr-view-m', views.m);
    section.setAttribute('data-nvr-view-d', views.d);

    section.querySelectorAll('[data-nvr-view]').forEach((button) => {
      const [kind, value] = button.dataset.nvrView.split('-');
      const active = views[kind] === value;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    // Com 1 produto por linha no celular, a foto ocupa a tela toda: pede imagem maior.
    const single = views.m === '1';
    section.querySelectorAll('img.nivieree-card__image').forEach((img) => {
      if (img.dataset.nvrSizes === undefined) img.dataset.nvrSizes = img.getAttribute('sizes') || '';
      const wanted = single ? '(max-width: 899px) 100vw, 25vw' : img.dataset.nvrSizes;
      if (wanted && img.getAttribute('sizes') !== wanted) img.setAttribute('sizes', wanted);
    });
  };

  /* ---------- Quantidade no título ---------- */

  const syncHeadingCount = () => {
    const target = document.querySelector('[data-nvr-heading-count]');
    const source = document.querySelector(SECTION + ' .nivieree-collection-count p');
    if (target && source && target.textContent.trim() !== source.textContent.trim()) {
      target.textContent = source.textContent.trim();
    }
  };

  /* ---------- Ordenar no celular ---------- */

  const forwardSortChoice = (event) => {
    const popover = event.target.closest?.('x-popover.nvr-sort-popover');
    if (!popover || popover.closest('facet-sort-by')) return; // no lugar certo: o tema resolve

    const host = popover._originalParentBeforeAppend;
    if (!host || !host.isConnected || host.tagName !== 'FACET-SORT-BY') return;

    host.dispatchEvent(new CustomEvent('listbox:change', { bubbles: true, detail: event.detail }));
  };

  // Depois que a barra é redesenhada, a cópia antiga do menu pode ficar solta no fim da página.
  const removeStaleSortMenus = () => {
    Array.from(document.body.children).forEach((child) => {
      if (child.matches('x-popover.nvr-sort-popover') && !child.hasAttribute('open')) child.remove();
    });
  };

  /* ---------- Filtros: Limpar e contagem do Aplicar ---------- */

  const clearFilters = (link) => {
    const section = document.querySelector(SECTION);
    if (!section) return false;

    const url = new URL(link.href, window.location.origin);
    url.searchParams.set('section_id', section.id.replace('shopify-section-', ''));

    // Fecha a gaveta sem reenviar os filtros antigos.
    const drawer = link.closest('facet-drawer');
    const form = drawer?.querySelector('form[is="facet-form"]');
    if (form) form._isDirty = false;
    drawer?.hide?.();

    section.dispatchEvent(new CustomEvent('facet:update', { bubbles: true, detail: { url } }));
    return true;
  };

  const countActiveFilters = (form) => {
    const keys = new Set();
    new FormData(form).forEach((value, key) => {
      if (!key.startsWith('filter.') || value === '') return;
      // Mínimo e máximo de preço contam como um filtro só.
      keys.add(key.startsWith('filter.v.price.') ? 'price' : key + '=' + value);
    });
    return keys.size;
  };

  const syncApplyCount = () => {
    document.querySelectorAll('button[is="facet-apply-button"]').forEach((button) => {
      const form = button.closest('form');
      const counter = button.filterCountElement || button.querySelector(':scope > span:last-child');
      if (!form || !counter) return;
      const total = countActiveFilters(form);
      const text = total > 0 ? ` (${total})` : '';
      if (counter.textContent !== text) counter.textContent = text;
    });
  };

  /* ---------- Cliques ---------- */

  const handleClick = (event) => {
    const clearLink = event.target.closest('[data-nvr-facets-clear]');

    if (clearLink) {
      if (clearFilters(clearLink)) event.preventDefault();
      return;
    }

    const viewButton = event.target.closest('[data-nvr-view]');

    if (viewButton) {
      event.preventDefault();
      const [kind, value] = viewButton.dataset.nvrView.split('-');
      const next = { ...currentViews(), [kind]: value };
      sessionViews = next;
      writeViews(next);
      applyViews();
      return;
    }

    const viewDot = event.target.closest('[data-nvr-color-bar] [data-nvr-color]');

    if (viewDot && isViewMode()) {
      event.preventDefault();
      const next = store.get() === viewDot.dataset.nvrColor ? '' : viewDot.dataset.nvrColor;
      store.set(next);
      syncBar(next);
      document.querySelectorAll(GRID_CARDS).forEach((card) => applyToCard(card, next));
      return;
    }

    const filterDot = event.target.closest('[data-nvr-color-bar] [data-nvr-param]');

    if (filterDot) {
      event.preventDefault();
      const url = new URL(window.location.href);
      const param = filterDot.dataset.nvrParam;
      url.searchParams.delete(param);
      url.searchParams.delete('page');
      if (!filterDot.classList.contains('is-active')) url.searchParams.append(param, filterDot.dataset.nvrValue);
      window.location.assign(url.toString());
    }
  };

  /* ---------- Início ---------- */

  const start = () => {
    document.addEventListener('click', handleClick);
    document.addEventListener('listbox:change', forwardSortChoice);
    // O tema atualiza o número no próprio formulário; este ouvinte roda depois e corrige.
    document.addEventListener('change', syncApplyCount);
    document.addEventListener('dialog:after-show', syncApplyCount);
    applyViews();
    applyColor(document);
    syncHeadingCount();
    syncApplyCount();

    // Filtros, ordenação e paginação trocam a grade sem recarregar a página, e a
    // gaveta de filtros é movida para o fim da página ao abrir (o tema recalcula o
    // número do Aplicar nessa hora). O observador da grade foi registrado antes deste,
    // então os cards novos já estão preparados quando este callback roda.
    new MutationObserver((mutations) => {
      let barChanged = false;
      let applyMoved = false;
      const added = [];

      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== 1) return;
          if (node.matches?.('[data-nvr-color-bar], .collection__top-bar') || node.querySelector?.('[data-nvr-color-bar]')) barChanged = true;
          if (node.matches?.('[data-nivieree-card]') || node.querySelector?.('[data-nivieree-card]')) added.push(node);
          if (node.querySelector?.('button[is="facet-apply-button"]')) applyMoved = true;
        });
      });

      if (applyMoved) syncApplyCount();
      if (!barChanged && !added.length) return;

      applyViews();
      if (barChanged) {
        applyColor(document);
        window.setTimeout(removeStaleSortMenus, 600);
      } else {
        added.forEach((node) => applyColor(node));
      }
      syncHeadingCount();
      syncApplyCount();
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
